"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateValues = exports.updateErrors = exports.setValues = exports.setRegisteredFields = exports.setInit = exports.setErrors = exports.resetForm = exports.initializeForm = exports.getValues = exports.getErrors = exports.deleteForm = exports.changeValue = void 0;
var _reduxActions = require("redux-actions");
var _FormTypes = require("./types/FormTypes");
const {
  updateErrors,
  getErrors,
  setErrors,
  setInit,
  changeValue,
  deleteForm,
  initializeForm,
  updateValues,
  getValues,
  setValues,
  resetForm,
  setRegisteredFields
} = (0, _reduxActions.createActions)({
  [_FormTypes.DELETE_FORM]: payload => payload,
  [_FormTypes.UPDATE_ERRORS]: payload => payload,
  [_FormTypes.GET_ERRORS]: payload => payload,
  [_FormTypes.SET_ERRORS]: payload => payload,
  [_FormTypes.UPDATE_VALUES]: payload => payload,
  [_FormTypes.GET_VALUES]: payload => payload,
  [_FormTypes.SET_VALUES]: payload => payload,
  [_FormTypes.INITIALIZE_FORM]: payload => payload,
  [_FormTypes.CHANGE_VALUE]: payload => payload,
  [_FormTypes.RESET_FORM]: payload => payload,
  [_FormTypes.SET_REGISTERED_FIELDS]: payload => payload
});
exports.setRegisteredFields = setRegisteredFields;
exports.resetForm = resetForm;
exports.setValues = setValues;
exports.getValues = getValues;
exports.updateValues = updateValues;
exports.initializeForm = initializeForm;
exports.deleteForm = deleteForm;
exports.changeValue = changeValue;
exports.setInit = setInit;
exports.setErrors = setErrors;
exports.getErrors = getErrors;
exports.updateErrors = updateErrors;